export default __webpack_public_path__ + "static/media/chips1.b4cd4212.svg";